import PropTypes from "prop-types"

import Header from "./header"
import Footer from "./footer"
import "./layout.css"
import "./styles.scss"

const Layout = ({ children }: any) => {
  return (
    <>
      <Header />
      <main>{children}</main>
      <Footer />
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
